import script from "./EditBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditBtn.vue?vue&type=script&lang=ts&setup=true"

import "./EditBtn.vue?vue&type=style&index=0&id=d99a4490&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d99a4490"]])

export default __exports__